"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_breadcrumb_1 = require("@hotelplan/components.common.breadcrumb");
const components_common_image_1 = require("@hotelplan/components.common.image");
const CheckoutWaitingScreenWrapper = styled_components_1.default.div(({ theme }) => theme.checkout.checkoutWaitingScreenWrapper);
const ContentWrapper = styled_components_1.default.div(({ theme }) => theme.checkout.content);
const CheckoutWaitingScreen = ({ title, subTitle, image, text, productName, breadCrumbs, paymentMethods, }) => {
    return (react_1.default.createElement(CheckoutWaitingScreenWrapper, null,
        title && react_1.default.createElement("h3", null, title),
        react_1.default.createElement("div", { className: "loading-animation-wrapper" },
            react_1.default.createElement("div", { className: "dots" }),
            react_1.default.createElement("div", { className: "dots" }),
            react_1.default.createElement("div", { className: "dots" }),
            react_1.default.createElement("div", { className: "dots" }),
            react_1.default.createElement("div", { className: "dots" }),
            react_1.default.createElement("div", { className: "dots" })),
        react_1.default.createElement(ContentWrapper, null,
            react_1.default.createElement("div", { className: "img-wrap" },
                react_1.default.createElement(components_common_image_1.Image, Object.assign({}, image, { className: "checkout-waiting-screen-img" }))),
            react_1.default.createElement("div", { className: "content-wrap" },
                react_1.default.createElement("div", { className: "product-details" },
                    productName && react_1.default.createElement("h2", { className: "product-name" }, productName),
                    breadCrumbs && react_1.default.createElement(components_common_breadcrumb_1.Breadcrumb, { items: breadCrumbs })),
                subTitle && (react_1.default.createElement("div", { className: "subtitle-text", dangerouslySetInnerHTML: { __html: subTitle } })),
                text && (react_1.default.createElement("div", { className: "rich-text", dangerouslySetInnerHTML: { __html: text } }))),
            react_1.default.createElement("div", { className: "payment-methods" }, paymentMethods))));
};
exports.default = CheckoutWaitingScreen;
//# sourceMappingURL=CheckoutWaitingScreen.js.map